import {
  Hammer,
  Images,
  MapPin,
  Phone,
  Leaf,
  Calendar,
  HardHat,
  Truck,
  Wrench,
  Star,
  Bell,
} from "lucide-react";

// Map of icon names (as stored in the entity) to lucide-react components.
// When adding new mockup_features in the dashboard, use these exact names.
export const CONCEPT_ICONS = {
  Hammer,
  Images,
  MapPin,
  Phone,
  Leaf,
  Calendar,
  HardHat,
  Truck,
  Wrench,
  Star,
  Bell,
};

export function getConceptIcon(name) {
  return CONCEPT_ICONS[name] ?? Star;
}

// Parse "IconName|Label" strings into { icon, label } objects.
export function parseMockupFeatures(features) {
  if (!features) return [];
  return features.map((str) => {
    const sep = str.indexOf("|");
    if (sep === -1) return { icon: Star, label: str };
    const iconName = str.slice(0, sep).trim();
    const label = str.slice(sep + 1).trim();
    return { icon: getConceptIcon(iconName), label };
  });
}

// Parse "Day|Title" strings into { day, title } objects.
export function parseEvents(events) {
  if (!events) return [];
  return events.map((str) => {
    const sep = str.indexOf("|");
    if (sep === -1) return { day: "", title: str };
    return { day: str.slice(0, sep).trim(), title: str.slice(sep + 1).trim() };
  });
}

// Transform an entity record (snake_case) into the camelCase shape
// that ConceptCard / ConceptMockup / ConceptDetail expect.
export function transformConcept(record) {
  if (!record) return null;
  return {
    id: record.id,
    slug: record.slug,
    title: record.title,
    name: record.name,
    domain: record.domain,
    accent: record.accent || "#4C6B3A",
    layout: record.layout || "cover",
    variant: record.variant || "stacked",
    featuresStyle: record.features_style || "list",
    span: record.span || "",
    heroImage: record.hero_image,
    heroTitle: record.hero_title,
    heroSubtitle: record.hero_subtitle,
    ctaLabel: record.cta_label,
    summary: record.summary,
    navLinks: record.nav_links || [],
    features: record.features || [],
    mockupFeatures: parseMockupFeatures(record.mockup_features),
    reviews: record.reviews,
    reviewCount: record.review_count,
    timeSlots: record.time_slots,
    serviceTime: record.service_time,
    events: parseEvents(record.events),
    itemType: record.item_type || "concept",
    clientUrl: record.client_url,
    caseProblem: record.case_problem,
    caseSolution: record.case_solution,
    caseResults: record.case_results || [],
    sortOrder: record.sort_order || 0,
    published: record.published !== false,
  };
}